import { useEffect } from "react";
import { Link } from "react-router-dom";
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import formGuruLogo from "../assests/form-guru-logo-trnsparent.png";
import { AppStoreBadge, GooglePlayBadge } from "./StoreBadges";

export default function DownloadAppModal({ isOpen, onClose, planName }) {
  // Lock body scroll and close on ESC key while modal is open
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    };

    if (isOpen) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyDown);
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[1200] flex items-center justify-center p-4 backdrop-blur-[16px]"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="download-modal-title"
    >
      <div
        className="relative w-full max-w-lg bg-[var(--color-surface)] border border-[var(--color-border)] rounded-[var(--radius-md)] overflow-hidden text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="absolute top-0 left-0 right-0 h-[3px] bg-[linear-gradient(90deg,transparent,var(--color-primary),transparent)]" />
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 inline-flex items-center justify-center rounded-[var(--radius-md)] text-[var(--color-text-muted)] border-none cursor-pointer"
        >
          <CloseOutlined sx={{ fontSize: 20 }} />
        </button>
        <div className="px-4 py-8">
          <div className="flex justify-center items-center gap-3 mb-6">
            <img
              src={formGuruLogo}
              alt="Form Guru"
              className="h-20 w-auto"
            />
            <span className="brand-wordmark text-[28px] text-[var(--color-text)]">
              FORM<span className="text-[var(--color-primary)]"> GURU</span>
            </span>
          </div>
          <h2
            id="download-modal-title"
            className="text-2xl font-bold tracking-tight text-[var(--color-text)] mb-3"
          >
            Get the App to Subscribe
          </h2>
          {planName && (
            <span className="inline-block mb-4 py-2 px-4 rounded-full text-xs font-bold uppercase tracking-widest bg-[rgba(200,255,0,0.12)] border border-[rgba(200,255,0,0.25)] text-[var(--color-primary)]">
              {planName} plan
            </span>
          )}
          <p className="text-sm leading-relaxed text-[var(--color-text-muted)] mb-8">
            Subscriptions are managed exclusively through our mobile app.
            Download{" "}
            <span className="text-[var(--color-text-muted)] font-semibold">
              your{" "}
            <span className="text-[var(--color-text)]">The FormGuru</span>
            </span>{" "}
            app and unlock your chosen plan in seconds.
          </p>

          <div className="h-px bg-[var(--color-border)]" />

          <div className="flex md:flex-row flex-col items-center justify-center gap-4 mt-8">
            <Link
              to="https://play.google.com/store/apps/details?id=com.horserace.app&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-200 hover:scale-105 active:scale-95"
              aria-label="Get it on Google Play"
            >
              <GooglePlayBadge height={52} />
            </Link>
            <Link
              to="https://apps.apple.com/us/app/formguru-horserace/id6784553692"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-200 hover:scale-105 active:scale-95"
              aria-label="Download on the App Store"
            >
              <AppStoreBadge height={52} />
            </Link>
          </div>
          <p className="mt-6 text-xs text-[var(--color-text-muted)]">
            Available on iOS &amp; Android · Free to download
          </p>
        </div>
      </div>
    </div>
  );
}
